import React, { useState } from 'react';
import { ExternalLink } from 'lucide-react';
import App from './App';

// Import your existing App component
const AppWrapper = () => {
  const [showDashboard, setShowDashboard] = useState(false);

  // If showing dashboard, render the existing App content
  if (showDashboard) {
    return <App />;  // Your existing App component
  }

  // Otherwise show landing page
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      <div className="h-screen flex flex-col items-center justify-center p-6">
        {/* Title */}
        <h1 className="text-7xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-emerald-400 to-blue-500 pb-3">
          Insight50
        </h1>
        
        {/* Subtitle */}
        <p className="text-2xl text-gray-300 mb-12">
          AI-powered Analytics for SANFL
        </p>

        {/* Enter button */}
        <button
          onClick={() => setShowDashboard(true)}
          className="group flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-emerald-500 to-blue-500 
                     rounded-xl text-xl font-semibold hover:from-emerald-600 hover:to-blue-600 
                     transform hover:scale-105 transition-all duration-300"
        >
          Enter Platform
          <ExternalLink className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
        </button>
      </div>
    </div>
  );
};

export default AppWrapper;